module.exports = __webpack_public_path__ + "static/software-6220141e8606cdfae26f7ccf8a4c6e91.png";